export const DASHBOARD_BLOCK_SET_DATA = 'DASHBOARD_BLOCK_SET_DATA';
export const DASHBOARD_BLOCK_RESET_DATA = 'DASHBOARD_BLOCK_RESET_DATA';
